
export const mainCategoryLoadSuccess = (categories) => {
    return {
        type : 'MAIN_CATEGORY_LOAD_SUCCESS',
        payload : {
            categories
        }
    }
}
export const subCategoryLoadSuccess = (subCategories) => {
    return {
        type : 'SUB_CATEGORY_LOAD_SUCCESS',
        payload : {
            subCategories
        }
    }
}

export const loadCategory = ()=> {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const category = getState().category;

        const mainCategoryRef = firebase.ref().child('category/mainCategory');
        const subCategoryRef = firebase.ref().child('category/subCategory');

        mainCategoryRef.on('value', (snapshot) => {
            let mainCategories = [];
            snapshot.forEach(main => {
                mainCategories.push({
                    id : main.key, 
                    text: main.val() 
                })
            });
            dispatch(mainCategoryLoadSuccess(mainCategories));
        })

        subCategoryRef.on('value', (snapshot) => {
            let subCategories = [];
            snapshot.forEach(sub => {
                let subCats = [];
                const subVal = sub.val();
                for(let key in subVal){
                    subCats.push({
                        id : key,
                        text : subVal[key]
                    })
                }
                subCategories.push(subCats);
            })
            dispatch(subCategoryLoadSuccess(subCategories));
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/Store/actions/categoryActions.js